// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"4ffbe006","210":"199da8d1","274":"722906c2","832":"eeb6d063","888":"62f7037b","892":"6db7b9b7"}[chunkId] + ".css";
};